import competenciesTypes from '../../constants/competenciesTypes'
export * from './get'
export * from './create'
export * from './getindex'
// export * from './publish'
// export * from './unpublish'
export * from './update'

const set_competency_errors = (messages) => {
  return {
    type: competenciesTypes.set_errors,
    payload: messages
  }
}

const reset_competency = () => {
  return {
    type: competenciesTypes.reset
  }
}

export {
  set_competency_errors,
  reset_competency,
}



// WEBPACK FOOTER //
// ./src/js/actions/competencies/index.js